import React, { useEffect, useState } from "react"
import { Container } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import Payments from "./Payments"
import PaymentPage from "./paymentPage"

const UserPayments = () => {
  const tabs = ["PAYMENTS", "ICD_PAYMENTS"]
  const [activeTab, setActiveTab] = useState("")

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace("#", "").toUpperCase()
      if (tabs.includes(hash)) {
        setActiveTab(hash)
      } else {
        setActiveTab("PAYMENTS")
        window.location.hash = "PAYMENTS"
      }
    }

    handleHashChange()
    window.addEventListener("hashchange", handleHashChange)

    return () => window.removeEventListener("hashchange", handleHashChange)
  }, [])

  const HeaderComponent = () => (
    <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 justify-content-between">
      <div className="investment-trends-tab-section mb-3">
        <div onClick={() => setActiveTab("PAYMENTS")} className="tab-box">
          <p
            className={activeTab === "PAYMENTS" ? "active" : ""}
            style={{ minWidth: "150px" }}
          >
            Payment Approvals
          </p>
        </div>
        <div onClick={() => setActiveTab("ROLE")} className="tab-box">
          <p
            className={activeTab === "ROLE" ? "active" : ""}
            style={{ minWidth: "150px" }}
          >
            Admin Payments
          </p>
        </div>
      </div>
    </div>
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={"Payments"} />
          {activeTab === "PAYMENTS" && (
            <Payments HeaderComponent={HeaderComponent} />
          )}
          {activeTab === "ROLE" && (
            <PaymentPage HeaderComponent={HeaderComponent} />
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default UserPayments
